import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TooltipPositions } from '@gelato-api-ui/ui-kit/src/lib/tooltip/tooltip.enum';
import { CommonModule } from '@angular/common';
import { TooltipModule } from '@gelato-api-ui/ui-kit/src/lib/tooltip/tooltip.module';
import { AssetsPathPipe } from '@gelato-api-ui/sdk/src/lib/pipes/assets-path.pipe';

@Component({
  standalone: true,
  selector: 'lib-product-feature-label',
  templateUrl: './product-feature-label.component.html',
  styleUrls: ['./product-feature-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TooltipModule, AssetsPathPipe],
})
export class ProductFeatureLabelComponent {
  @Input() labelText: string;
  @Input() tooltipText: string;

  tooltipPosition = TooltipPositions.topCenter;
}
